import router from '@/router'
let locallyStoredAuthUser = window.localStorage.getItem('authUser')

const state = {
  authUser: locallyStoredAuthUser ? JSON.parse(locallyStoredAuthUser) : {},
};

const mutations = {
  SET_AUTH_USER(state, payload) {
    state.authUser = payload;
    window.localStorage.setItem('authUser', JSON.stringify(state.authUser))
  },
  CLEAR_AUTH_USER(state){
    state.authUser = {} 
    router.push("/login/signin")
    window.localStorage.removeItem('authUser')
  },
  // Al cambiar el nombre del usuario en el registro de usuarios de la CPNU 
  // se ha de cambiar aquí para que lo refleje
  SetNombre(state, nombre) {
    
    state.authUser.nombre = nombre;
  },
};

const getters = {
  isAuth(state) {
    return (state.authUser.jwt ? true : false);
  },
  getUser(state) {
    return state.authUser;
  },
  getUserName(state) {
    return state.authUser.nombre;
  },
  getUserRoles(state) {
    // // return state.authUser['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
    let roles = state.authUser['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
    if(!Array.isArray(roles)){
      roles=[roles]
    }
    return roles
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
